<template>
  <div
    class="left-drawer"
    :class="isShowLeft ? '' : 'active'"
    @mouseenter="isShowIcon = true"
    @mouseleave="isShowIcon = false"
    v-show = "!uiHiddenState.isHiddenLayer"
  >
    <!--    <Icon v-show="isShowIcon || !isShowLeft" type="big" name="el-icon-d-arrow-left" @click.native="showPanel"></Icon>-->
    <div
      v-show="
        (isShowIcon || !isShowLeft) &&
        !isDrawState &&
        !spaceSearchJeojson &&
        !isShowSpaceTool
      "
      class="arrow"
      @click="showPanel"
      :class="!isShowLeft ? 'active' : ''"
    >
      <i class="el-icon-arrow-left"></i>
    </div>
    <div class="content">
      <div class="header">
        <slot name="header"></slot>
      </div>
      <div class="body">
        <slot name="body"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'LeftDrawer',
  props: {},
  computed: {
    ...mapGetters([
      'isShowLeft',
      'isDrawState',
      'spaceSearchJeojson',
      'isShowSpaceTool',
      'uiHiddenState'
    ])
  },
  data () {
    return {
      isShowIcon: false
    }
  },
  watch: {
    isShowLeft (val) {
      this.$store.dispatch('setLeftDrawVisible', val)
    }
  },
  mounted () {
    this.$store.dispatch('setLeftDrawVisible', this.isShowLeft)
  },
  destroyed () {
    this.$store.dispatch('setLeftDrawVisible', false)
  },
  methods: {
    showPanel () {
      this.$store.dispatch('showLeft', !this.isShowLeft)
    }
  }
}
</script>

<style lang="scss" scoped>
.left-drawer {
  box-sizing: border-box;
  transition: all 0.3s;
  display: inline-block;
  position: absolute;
  top: 0px;
  // top: 48px;
  left: 0px;
  width: 260px;
  height: 100%;
  background: #2c2d2e;
  box-shadow: 1px 2px 6px 0px rgba(0, 0, 0, 0.1);
  border-right: 1px solid #000000;
  z-index: 1;
  > .custom-icon {
    position: absolute;
    right: -32px;
    top: 400px;
    z-index: 1000;
  }
  .arrow {
    position: absolute;
    right: -16px;
    top: 400px;
    z-index: 1000;
    width: 32px;
    height: 32px;
    background: #0098f0;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    cursor: pointer;
    &.active {
      transform: rotate(180deg);
      right: -20px;
    }
  }
  .content {
    height: 100%;
    display: flex;
    flex-direction: column;
    .header {
      height: 40px;
      min-height: 40px;
      border-bottom: 1px solid #000000;
    }
    .body {
      box-sizing: border-box;
      flex-grow: 1;
      flex-shrink: 0;
      flex-basis: 0%;
      overflow-y: auto;
    }
  }

  &.active {
    // width: 0;
    // .content{
    //   display: none;
    // }
    left: -260px;
  }
}
</style>
